import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense.ts";
import { ReturnRequestLogDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@babackapp/ui/components/accordion";
import { Badge } from "@babackapp/ui/components/badge";
import { TruckIcon } from "lucide-react";
import ActivityContentWrapper from "./activity-content-wrapper";
import ActivityIconWrapper from "./activity-icon-wrapper";
import { ActivityItemHeader } from "./activity-item-header";
import ActivityWrapper from "./activity-wrapper";
import { getAuthorName } from "@/pages/(app)/returns/utils/get-author-name.ts";

type UpdateCarrierActivityProps = {
  activity: ReturnRequestLogDto;
};

export default function UpdateCarrierActivity({
  activity,
}: UpdateCarrierActivityProps) {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();

  const author = shop.users.find(
    (user) => user.userId === activity.author,
  )?.user;
  const authorName = getAuthorName(author);

  const previousCarrier: string = activity.params?.previousCarrier as string;
  const newCarrier: string = activity.params?.newCarrier as string;
  const newCarrierTitle: string | null = activity.params
    ?.newCarrierTitle as string;
  const previousCarrierTitle: string | null = activity.params
    ?.previousCarrierTitle as string | null;
  const labelRegenerated: boolean = activity.params
    ?.labelRegenerated as boolean;

  return (
    <ActivityWrapper>
      <ActivityIconWrapper>
        <TruckIcon className="size-4" />
      </ActivityIconWrapper>
      <ActivityContentWrapper>
        <div className="flex items-center gap-2 flex-1 justify-between w-full">
          <Accordion type="single" collapsible className="flex-1">
            <AccordionItem value="item-1" className="border-0">
              <AccordionTrigger className="p-0 w-full">
                <ActivityItemHeader title="" timestamp={activity.date}>
                  <span className="font-bold">{authorName}</span>
                  {t("returnDetail.modifiedCarrier")}
                  <span className="font-bold">
                    {newCarrierTitle || newCarrier}
                  </span>
                </ActivityItemHeader>
              </AccordionTrigger>
              <AccordionContent>
                <div className="mt-2 space-y-1">
                  {!!previousCarrier && !!newCarrier && (
                    <div className="flex items-center gap-2 text-xs">
                      <Badge variant="outline" className="text-xs">
                        {previousCarrierTitle || previousCarrier}
                      </Badge>
                      <span className="text-muted-foreground">→</span>
                      <Badge variant="outline" className="text-xs">
                        {newCarrierTitle || newCarrier}
                      </Badge>
                    </div>
                  )}
                  {!!labelRegenerated && (
                    <div className="text-xs text-muted-foreground mt-1">
                      ({t("returnDetail.labelRegenerated")})
                    </div>
                  )}
                </div>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </ActivityContentWrapper>
    </ActivityWrapper>
  );
}
